import axios from 'axios';

// Set base API URL from environment variable or fallback
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Axios interceptor to attach JWT Authorization header to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);

// An expired or invalid token makes every request fail; send the user back to sign in.
axios.interceptors.response.use(
  (response) => response,
  (error: any) => {
    const isAuthCall = String(error.config?.url || '').includes('/api/auth/');
    if (error.response?.status === 401 && !isAuthCall && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export default axios;
